<div *nzModalTitle class="create-company__top">Create new company</div>
<form
  action="/"
  class="company-new"
  (ngSubmit)="onSubmit()"
  [formGroup]="companyNewForm"
>
  <div class="row clearfix">
    <div class="col-6">
      <div class="form-group">
        <label for="newCompanyNameInput">Company *</label>
        <input
          nz-input
          class="form-control"
          type="text"
          name="name"
          id="newCompanyNameInput"
          formControlName="name"
        />
      </div>
      <div class="form-group">
        <label for="newCompanyDomainInput">Domain</label>
        <input
          nz-input
          type="text"
          class="form-control"
          name="domain"
          id="newCompanyDomainInput"
          formControlName="domain"
        />
      </div>
      <div class="form-group">
        <label for="newCompanyContactInput">Contact</label>
        <input
          nz-input
          type="text"
          class="form-control"
          name="contact"
          id="newCompanyContactInput"
          formControlName="contact"
        />
      </div>
      <div class="form-group">
        <label for="newCompanyEmailInput">Email *</label>
        <input
          nz-input
          type="text"
          class="form-control"
          name="email"
          id="newCompanyEmailInput"
          formControlName="email"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="newCompanyTermsInput">Terms</label>
        <nz-input-group nzAddOnBefore="NET">
          <input
            nz-input
            type="text"
            class="form-control"
            name="terms"
            id="newCompanyTermsInput"
            (input)="clearNonDigit($event)"
            formControlName="terms"
          />
        </nz-input-group>
      </div>

      <div class="form-group form-group_dp">
        <label for="picker" style="margin-right: 5px">Start Date</label>
        <nz-date-picker
          [nzAllowClear]="false"
          style="margin-left: 5px"
          name="picker"
          [nzDisabledDate]="disabledDate"
          formControlName="start"
        ></nz-date-picker>
      </div>
    </div>
  </div>
  <div *nzModalFooter>
    <button
      buttonLabel="modalCreateNewCompany"
      nz-button
      type="submit"
      nzType="primary"
      (click)="onSubmit()"
    >
      Create
    </button>
    <button
      buttonLabel="cancelCreateNewCompany"
      nz-button
      type="button"
      nzType="default"
      class="btn-cancel"
      (click)="onCancelClick($event)"
    >
      Cancel
    </button>
  </div>
</form>
